export default __webpack_public_path__ + "static/media/779.8a30a0e6.png";